import 'jquery';
import '../utils/slick.js';

$(function () {
    var slider = $('.feature-discover .feature-discover__cards');
    var cards = $('.feature-discover .feature-discover__card');
    var slickInitialized = false;

    function initSlider() {
        slider.css('opacity', 0);
        slider.on('init', function() {
            slider.css('opacity', 1);
        });

        slider.slick({
            slidesToShow: 1,
            centerMode: true,
            centerPadding: '18%',
            prevArrow: '<div class="arrow-left"></div>',
            nextArrow: '<div class="arrow-right"></div>',
        });
        slickInitialized = true;
    }

    function destroySlider() {
        if (slickInitialized) {
            slider.slick('unslick');
            slickInitialized = false;
        }
    }

    function removeSalAnimate(){
        cards.each(function () {
            $(this).removeClass('sal-animate');
            $(this).removeAttr('data-sal');
            $(this).removeAttr('data-sal-duration');
            $(this).removeAttr('data-sal-delay');
        });
    }

    function handleResize() {
        var isMobile = $(window).width() <= 768;

        if (isMobile && !slickInitialized) {
            removeSalAnimate();
            initSlider();
        } else if (!isMobile && slickInitialized) {
            destroySlider();
        }
    }

    handleResize();

    window.addEventListener("resize", function () {
        setTimeout(function(){
            handleResize();
        }, 100);
    });
});
